import { render, staticRenderFns } from "./ContactOrderStatistics.vue?vue&type=template&id=64689ffe&scoped=true&"
import script from "./ContactOrderStatistics.vue?vue&type=script&lang=js&"
export * from "./ContactOrderStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64689ffe",
  null
  
)

export default component.exports